export default __webpack_public_path__ + "static/media/litecampus-pin-red.9084fd06.svg";